import { render, staticRenderFns } from "./ClicksAnalytics.vue?vue&type=template&id=0d84076e&"
import script from "./ClicksAnalytics.vue?vue&type=script&lang=js&"
export * from "./ClicksAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports